import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function NotFound() {
  const { t } = useTranslation();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-background-100 px-4 text-center">
      <span className="mb-4 flex h-16 w-16 items-center justify-center rounded-full bg-primary-100 text-primary-600">
        <i className="ri-compass-3-line text-3xl leading-none" aria-hidden="true" />
      </span>
      <p className="text-4xl font-black text-background-300">404</p>
      <h1 className="mt-2 text-xl font-bold text-foreground-950 md:text-2xl">{t("notFound.title")}</h1>
      <p className="mt-2 max-w-md text-sm text-foreground-500">{t("notFound.text")}</p>
      <Link
        to="/dashboard"
        className="mt-6 inline-flex h-11 items-center rounded-md bg-primary-500 px-6 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
      >
        {t("notFound.action")}
      </Link>
    </div>
  );
}